export default __webpack_public_path__ + "static/highlight-5-mobile-07ac1c5e22bb94d0ee204f533aa0543d.svg";